import _ from 'lodash';

export default {
    props: {
        isLoading: Boolean,
        type: String,
        data: {
            type: Array,
            default: () => [],
        },
        estimatedAmount: { type: Number, default: 0 },
        estimatedProjectAmount: Number,
    },
    computed: {
        totalAmt() {
            return _.sumBy(this.data, (o) => o.actuallyAmount + o.nonProjectAmount + o.projectAmount + o.futureAmt);
        },
        distributedNonProjectAmt() {
            return _.sumBy(this.data, 'nonProjectAmount');
        },
        distributedProjectAmt() {
            return _.sumBy(this.data, 'projectAmount');
        },
        nonDistributedNonProjectAmt() {
            return Math.round(this.estimatedAmount) - _.sumBy(this.data, 'nonProjectAmount');
        },
        nonDistributedProjectAmt() {
            return Math.round(this.estimatedProjectAmount) - _.sumBy(this.data, 'projectAmount');
        },
        actuallyAmount() {
            return _.sumBy(this.data, (o) => o.actuallyAmount);
        },
        futureAmount() {
            return _.sumBy(this.data, (o) => o.futureAmt);
        },
    },
    methods: {
        getPercentage(value, total) {
            if (!value || !total) return '--';
            return Math.round((value / total) * 10000) / 100;
        },
        getTotalAmt(row) {
            return row.actuallyAmount + row.nonProjectAmount + row.projectAmount + row.futureAmt;
        },
    },
};
